<div class="timepicker-wrapper">
  <img
    [src]="assetUrl + 'icons/clock.svg'"
    alt="clock"
    class="timepicker-icon"
  />

  <button
    type="button"
    class="time-trigger"
    cdkOverlayOrigin
    #startOrigin="cdkOverlayOrigin"
    (click)="toggleMenu('start')"
  >
    {{ formatDisplayTime(startTime) }}
  </button>

  <span class="time-separator">–</span>

  <button
    type="button"
    class="time-trigger"
    cdkOverlayOrigin
    #endOrigin="cdkOverlayOrigin"
    (click)="toggleMenu('end')"
  >
    {{ formatDisplayTime(endTime) }}
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="openMenu === 'start' ? startOrigin : endOrigin"
  [cdkConnectedOverlayOpen]="openMenu !== null"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayPositions]="overlayPositions"
  (backdropClick)="closeMenus()"
  (detach)="closeMenus()"
>
  <div class="time-menu">
    <button
      type="button"
      class="time-option"
      *ngFor="let time of timeOptions"
      [class.is-selected]="
        time === (openMenu === 'start' ? startTime : endTime)
      "
      [class.is-disabled]="isTimeOptionDisabled(openMenu!, time)"
      [disabled]="isTimeOptionDisabled(openMenu!, time)"
      (click)="selectTime(openMenu!, time)"
    >
      {{ formatDisplayTime(time) }}
    </button>
  </div>
</ng-template>
